var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-swipe',{staticClass:"my-swipe",style:('border-radius:' + _vm.imageRadius + 'px;'),attrs:{"autoplay":3000,"show-indicators":false}},_vm._l((_vm.adImageList),function(img,index){return _c('van-swipe-item',{key:index},[_c('van-image',{attrs:{"radius":_vm.imageRadius,"src":img,"fit":"cover"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }